// plugins/drawing/drawingToolFactory.ts
import type { Dispatch, UnknownAction } from "redux";
import { createCesiumDrawing } from "./helpers/cesium";
import { createLeafletDrawing } from "./helpers/leaflet";
import { createMapLibreDrawing } from "./helpers/maplibre";
import { createOLDrawing } from "./helpers/openlayers";
import type { DrawFeature, DrawingMode } from "./types";

export function createDrawingTool(
  mapIntance: any,
  mapType: string,
  mode: DrawingMode,
  editingFeatureId: string | null,
  features: DrawFeature[],
  dispatch: Dispatch<UnknownAction> | any,
) {
  if (mapType === "openlayers") {
    return createOLDrawing(mapIntance, mode, editingFeatureId, features, dispatch);
  }

  if (mapType === "leaflet") {
    return createLeafletDrawing(mapIntance, mode);
  }

  if (mapType === "maplibre") {
    return createMapLibreDrawing(mapIntance, mode, editingFeatureId, features, dispatch);
  }

  if (mapType === "cesium") {
    return createCesiumDrawing(mapIntance, mode);
  }

  throw new Error("Unsupported engine");
}
